import React from 'react';
import { 
  HelpCircle, 
  Receipt, 
  Clock, 
  Percent, 
  FileText, 
  Wallet, 
  Zap, 
  MapPin
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по командировкам
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Receipt,
      title: 'Сохраняйте документы',
      description: 'Храните все билеты, посадочные талоны, чеки и квитанции. Это важно для налогового учета и компенсации расходов.'
    },
    {
      icon: Clock,
      title: 'Сроки авансового отчета',
      description: 'Авансовый отчет нужно сдать в течение 3 рабочих дней после возвращения из командировки.'
    },
    {
      icon: Percent,
      title: 'Налогообложение',
      description: 'Суточные не облагаются НДФЛ в пределах 700 руб. для командировок по России и 2500 руб. для зарубежных.'
    },
    {
      icon: FileText,
      title: 'Командировочное удостоверение',
      description: 'С 2015 года не обязательно, но многие организации продолжают его использовать для внутреннего учета.'
    },
    {
      icon: Wallet,
      title: 'Аванс на командировку',
      description: 'Работодатель обязан выдать аванс на командировочные расходы до выезда сотрудника.'
    },
    {
      icon: Zap,
      title: 'Досрочное возвращение',
      description: 'При досрочном возвращении из командировки сотруднику выплачиваются суточные за фактическое время.'
    },
    {
      icon: MapPin,
      title: 'Однодневные поездки',
      description: 'В однодневных командировках суточные могут не выплачиваться, но многие организации устанавливают свои правила.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по командировкам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Задавайте вопросы по расчету суточных и оформлению командировок профессиональным бухгалтерам.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;